import { Badge } from "@bowfast/ui/components/badge";
import { ArrowRightIcon, SailboatIcon } from "lucide-react";
import { EXP_STATUS_CONFIG } from "~/pages/vessels/vessels.config";
import type { VesselDetailAssignment } from "~/pages/vessels/vessels.types";

export function ExpeditionRow({ ea }: Readonly<{ ea: VesselDetailAssignment }>) {
  const { expedition: exp } = ea;
  const cfg = EXP_STATUS_CONFIG[exp.status];
  return (
    <div className="group flex items-center gap-4 py-3 first:pt-0 last:pb-0">
      <div className="flex size-11 shrink-0 flex-col items-center justify-center rounded-lg bg-muted">
        <SailboatIcon className="size-4 text-muted-foreground" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <p className="truncate text-sm font-semibold">{exp.name}</p>
          <Badge
            variant={cfg.variant}
            {...(cfg.dot ? { dotted: true } : {})}
            {...(cfg.pulse ? { pulse: true } : {})}
            className="text-[0.625rem]"
          >
            {cfg.label}
          </Badge>
        </div>
        <p className="mt-0.5 text-xs text-muted-foreground">
          {ea.role ?? "Vessel"} · {exp.departureDate ?? "—"}
        </p>
      </div>
      <div className="shrink-0 text-right">
        <p className="font-heading text-sm font-bold tabular-nums">{exp.crew.length} crew</p>
      </div>
      <ArrowRightIcon className="size-3.5 shrink-0 text-muted-foreground/0 transition-colors group-hover:text-muted-foreground/60" />
    </div>
  );
}
